"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFixed = exports.round = exports.isNumber = void 0;
function isNumber(value) {
    return typeof value === "number";
}
exports.isNumber = isNumber;
/**
 * Round number to nearest whole number. Different than Math.round()
 * round(-2.5) === -3 while Math.round(-2.5) === -2
 */
function round(num) {
    return (num >= 0 ? 1 : -1) * Math.round(Math.abs(num));
}
exports.round = round;
/**
 * Returns a number representing the given value with a fixed number of decimal places.
 *
 * @param numberValue - The number or string to be converted.
 * @param precision - The number of decimal places to round to. Default is 0.
 * @returns {number} - The input value rounded to the specified decimal places.
 */
function toFixed(numberValue, precision = 0) {
    const factor = Math.pow(10, precision);
    return Math.round(Number(numberValue) * factor) / factor;
}
exports.toFixed = toFixed;
